import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

// Utils
import faqUrl from '@/utils/urls/faqUrl';

import { colors } from '@/lib/analytics/colors';
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_25 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { url_faq_reach_impressions } from '@/lib/urls/faqUrls';

//Components
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const reachConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.facebook.page_reach',
    id: 'reach',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    social: FACEBOOK,
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.facebook.tooltip_reach"
            components={{
                LinkFaq: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                        className="text-icoBlue underline"
                        target="_blank"
                        href={faqUrl(url_faq_reach_impressions)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_25,
    type: 'kpi',
    orientation: ORIENTATION_VERTICAL,
    element: KPIDefault,
    loader: DefaultLoader
};
